export const DETALIZATION_REPORT_ACTIONS = {
  // ACTIONS PERIOD
  SET_INITIAL_STATE: 'DETALIZATION_REPORT:SET_INITIAL_STATE',
  SET_PERIOD_START: 'DETALIZATION_REPORT:SET_DETALIZATION_PERIOD_START',
  SET_PERIOD_END: 'DETALIZATION_REPORT:SET_DETALIZATION_PERIOD_END',
  SET_IS_PERIOD_DATA_VALID: 'DETALIZATION_REPORT:SET_IS_DETALIZATION_PERIOD_DATA_VALID',
  SET_IS_PERIOD_DATA_DIRTY: 'DETALIZATION_REPORT:SET_IS_DETALIZATION_PERIOD_DATA_DIRTY',
  // ACTIONS DOWNLOAD
  DOWNLOAD_REPORT: 'DETALIZATION_REPORT:DOWNLOAD_DETALIZATION_REPORT',
  DOWNLOAD_REPORT_ERROR: 'DETALIZATION_REPORT:DOWNLOAD_DETALIZATION_REPORT_ERROR',
  DOWNLOAD_REPORT_SUCCESS: 'DETALIZATION_REPORT:DOWNLOAD_DETALIZATION_REPORT_SUCCESS',
  // ACTIONS SEND
  SEND_REPORT: 'DETALIZATION_REPORT:SEND_DETALIZATION_REPORT',
  SEND_REPORT_ERROR: 'DETALIZATION_REPORT:SEND_DETALIZATION_REPORT_ERROR',
  SEND_REPORT_SUCCESS: 'DETALIZATION_REPORT:SEND_DETALIZATION_REPORT_SUCCESS',
};

export const MAX_REPORT_PERIOD_IN_DAYS = 31;
